function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCompareRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 9.33l-.95 3.02h1.92l-.97-3.02z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3H7a4 4 0 00-4 4v18a4 4 0 004 4h18a4 4 0 004-4V7a4 4 0 00-4-4zM9.62 8h1.74l2.43 7h-1.55l-.45-1.4H9.08L8.65 15H7.19l2.43-7zM14 24H7v-2h7v2zm0-4H7v-2h7v2zm11 4h-7v-2h7v2zm0-4h-7v-2h7v2zm-6-5V8h2.49a3.11 3.11 0 011.85.48A1.539 1.539 0 0124 9.82c.011.332-.08.66-.26.94a1.64 1.64 0 01-.79.56A2.25 2.25 0 0124 12a1.6 1.6 0 01.32 1 1.75 1.75 0 01-.69 1.48 3.1 3.1 0 01-1.91.52H19zm2.44-5.8h-1v1.62h1a1.43 1.43 0 00.81-.19.71.71 0 00.28-.63.68.68 0 00-.28-.62 1.52 1.52 0 00-.81-.18zm.23 2.8h-1.22v1.8h1.22a1.35 1.35 0 00.86-.23.86.86 0 00.29-.7.81.81 0 00-.3-.69 1.41 1.41 0 00-.85-.18z",
    fill: props.color
  }));
}

export default SvgIconCompareRexFilled;